import { Pipe, PipeTransform } from '@angular/core';
import { normalizeUrlSlug } from 'avn/modules/services/utils/url-slug.util';

@Pipe({ name: 'slugText' })
export class SlugTextPipe implements PipeTransform {
  public transform(value: string, ...args: string[]): string {
    const style = args[0];
    const reverse = args[1];
    const splitBy = args[2] || ' ';
    let convertedText = value || '';
    if (style === 'capitalize') {
      const words = convertedText.split(splitBy);
      const capitalizedWords = words.map((word) =>
        word !== 'and' ? word.charAt(0).toUpperCase() + word.slice(1) : word
      );
      convertedText = capitalizedWords.join(' ');
    } else if (style === 'uppercase') {
      convertedText = convertedText.toUpperCase();
    } else if (style === 'lowercase') {
      convertedText = convertedText.toLowerCase();
    }
    if (reverse === 'yes') {
      convertedText = normalizeUrlSlug(convertedText);
    } else {
      convertedText = convertedText.replace(/-/g, ' ');
    }
    return convertedText;
  }
}
